/**
 * FilterBar — Standard filter controls (entity, status, search, period).
 */
import React from 'react';

interface FilterOption {
  value: string;
  label: string;
}

interface FilterDef {
  key: string;
  label: string;
  type: 'select' | 'search';
  options?: FilterOption[];
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  width?: number;
}

interface FilterBarProps {
  filters: FilterDef[];
}

const selectStyle: React.CSSProperties = {
  padding: '7px 12px', fontSize: 13, fontWeight: 500,
  border: '1px solid var(--border-subtle)', borderRadius: 6,
  background: 'var(--bg-card)', color: 'var(--text-primary)',
  cursor: 'pointer', outline: 'none',
};

const inputStyle: React.CSSProperties = {
  padding: '7px 12px', fontSize: 13,
  border: '1px solid var(--border-subtle)', borderRadius: 6,
  background: 'var(--bg-card)', color: 'var(--text-primary)',
  outline: 'none',
};

export default function FilterBar({ filters }: FilterBarProps) {
  return (
    <div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
      {filters.map(f => (
        f.type === 'select' ? (
          <select
            key={f.key}
            value={f.value}
            onChange={e => f.onChange(e.target.value)}
            style={{ ...selectStyle, width: f.width }}
          >
            <option value="">{f.placeholder || `All ${f.label}`}</option>
            {(f.options || []).map(o => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        ) : (
          <input
            key={f.key}
            type="text"
            value={f.value}
            onChange={e => f.onChange(e.target.value)}
            placeholder={f.placeholder || `Search ${f.label}...`}
            style={{ ...inputStyle, width: f.width || 200 }}
          />
        )
      ))}
    </div>
  );
}
